@if (field.show) {
  <div
	[ngClass]="{'mb-3':field.inputType !== 'divider' &&
    field.inputType !== 'checkbox' &&
    field.inputType !== 'radios',
    'mt-3': field.inputType === '' || field.inputType === 'dialog-file'}"
    [class]="field.formGroupClass.join(' ')"
    >
    @if (
      field.inputType !== 'divider' &&
      field.inputType !== 'nop' &&
      field.inputType !== 'button'
      ) {
      <div
        class="d-flex justify-content-between align-items-end"
        >
        <app-input-label
          [field]="field"
          [name]="name"
          [filter]="filter"
        ></app-input-label>
        @if (field.toolpit) {
          <app-tooltip-input
            [message]="field.toolpit"
          ></app-tooltip-input>
        }
      </div>
    }
    <div>
      @switch (field.inputType) {
        @case ('nop') {
          <div>
            <app-nop-input [control]="null"></app-nop-input>
          </div>
        }
        <!-- Input type: text -->
        @case ('textbox') {
          <app-textbox-input
            [control]="field"
            [controlId]="name"
          ></app-textbox-input>
        }
        @case ('file') {
          <app-file-input
            [control]="field"
            [controlId]="name"
          ></app-file-input>
        }
        <!-- Input type: textarea -->
        @case ('textarea') {
          <app-texarea-input
            [control]="field"
            [controlId]="name"
          ></app-texarea-input>
        }
        <!-- Input type: select -->
        @case ('select') {
          <app-select-input
            [control]="field"
            [controlId]="name"
          ></app-select-input>
        }
        <!-- Input type: autocomplete -->
        @case ('autocomplete') {
          <app-autocomplete-input
            [control]="field"
            [controlId]="name"
          ></app-autocomplete-input>
        }
        <!-- Input type: checkbox -->
        @case ('checkbox') {
          <app-checkbox-input
            [control]="field"
            [controlId]="name"
          ></app-checkbox-input>
        }
        <!-- Input type: radios -->
        @case ('radios') {
          <app-radios-input
            [control]="field"
            [controlId]="name"
          ></app-radios-input>
        }
        <!-- Input type: list only readonly -->
        @case ('list') {
          <app-list-input
            [control]="field"
          ></app-list-input>
        }
        <!-- Input type: date -->
        @case (
          field.inputType === 'date' || field.inputType === 'date-range'
          ? field.inputType
          : ''
          ) {
          <app-date-input
            [control]="field"
            [controlId]="name"
          ></app-date-input>
        }
      }
    </div>
    <!-- Show info detail -->
    @if (field.inputType !== 'divider' && field.inputType !== 'noop') {
      <app-validation-input-message
        [statusMessage]="field.statusMessage"
      ></app-validation-input-message>
    }
  </div>
}
